import React from "react";
import { styled } from "styled-components";
import { MainColor } from "../../constant";

const TitleHeader = ({ en, th, margin, center }) => {
  return (
    <Container margin={margin}>
      <EnMsg center={center}>{en}</EnMsg>
      <ThMsg center={center}>{th}</ThMsg>
    </Container>
  );
};

const Container = styled.div`
  margin: ${(props) => (props.margin ? props.margin : "20px")};
  color: ${MainColor};
`;

const EnMsg = styled.div`
  font-size: 20px;
  text-align: ${(props) => (props.center ? "center" : "left")};
`;

const ThMsg = styled.div`
  font-size: 40px;
  font-weight: bold;
  text-align: ${(props) => (props.center ? "center" : "left")};
`;

export default TitleHeader;
